var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "2 3 18.4 19.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.5,13.85A1.11,1.11,0,1,1,3.39,15,1.11,1.11,0,0,1,4.5,13.85ZM3.39,11.21A1.11,1.11,0,1,0,4.5,10.1,1.11,1.11,0,0,0,3.39,11.21Zm0-3.75A1.11,1.11,0,1,0,4.5,6.35,1.11,1.11,0,0,0,3.39,7.47Zm3.42,9.33a1.11,1.11,0,1,0,1.11-1.11A1.11,1.11,0,0,0,6.81,16.79Zm0-3.75a1.11,1.11,0,1,0,1.11-1.11A1.11,1.11,0,0,0,6.81,13Zm0-3.75A1.11,1.11,0,1,0,7.92,8.19,1.11,1.11,0,0,0,6.81,9.3Zm0-3.75A1.11,1.11,0,1,0,7.92,4.44,1.11,1.11,0,0,0,6.81,5.55ZM10.1,18.71a1.11,1.11,0,1,0,1.11-1.11A1.11,1.11,0,0,0,10.1,18.71Zm0-3.75a1.11,1.11,0,1,0,1.11-1.11A1.11,1.11,0,0,0,10.1,15Zm0-3.75a1.11,1.11,0,1,0,1.11-1.11A1.11,1.11,0,0,0,10.1,11.21Zm0-3.75a1.11,1.11,0,1,0,1.11-1.11A1.11,1.11,0,0,0,10.1,7.47Zm0-3.75A1.11,1.11,0,1,0,11.21,2.6,1.11,1.11,0,0,0,10.1,3.72Zm3.42,13.08a1.11,1.11,0,1,0,1.11-1.11A1.11,1.11,0,0,0,13.52,16.79Zm0-3.75a1.11,1.11,0,1,0,1.11-1.11A1.11,1.11,0,0,0,13.52,13Zm0-3.75a1.11,1.11,0,1,0,1.11-1.11A1.11,1.11,0,0,0,13.52,9.3Zm0-3.75a1.11,1.11,0,1,0,1.11-1.11A1.11,1.11,0,0,0,13.52,5.55ZM16.81,15a1.11,1.11,0,1,0,1.11-1.11A1.11,1.11,0,0,0,16.81,15Zm0-3.75a1.11,1.11,0,1,0,1.11-1.11A1.11,1.11,0,0,0,16.81,11.21Zm0-3.75a1.11,1.11,0,1,0,1.11-1.11A1.11,1.11,0,0,0,16.81,7.47Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot);
export default __webpack_public_path__ + "static/media/dot.56c39b625ce62a73311869b69aa47481.svg";
export { ForwardRef as ReactComponent };